const translations = {
    updateUserSuccess: 'User has been updated successfully'
};

export default translations;
